import { render, staticRenderFns } from "./RegistroTeam.vue?vue&type=template&id=56687272&"
import script from "./RegistroTeam.vue?vue&type=script&lang=js&"
export * from "./RegistroTeam.vue?vue&type=script&lang=js&"
import style0 from "./RegistroTeam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports